import { Suspense } from 'react';
import { Link, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import OverLayLoader from '../components/OverLayLoader';
import UsersListSettingsView from './subviews/settings/UsersListSettingsView';
import UserSettingsView from '../views/UserSettingsView';
import PATH from '../helpers/routes.json';

const SettingsView = () => {
  const { t } = useTranslation(['common']);
  const { pathname } = useLocation();

  return (
    <Box>
      <Tabs
        value={pathname}
        textColor="primary"
        indicatorColor="primary"
        aria-label="Dictionaries"
      >
        {Object.keys(PATH.settings.tabs).map(tab => (
          <Tab
            key={tab}
            value={PATH.settings.tabs[tab]}
            label={t(`pages.settings.tabs.${tab}`)}
            component={Link}
            to={PATH.settings.tabs[tab]}
          />
        ))}
      </Tabs>

      <Box pt={3}>
        <Suspense fallback={<OverLayLoader />}>
          <Routes>
            <Route path="/" element={<Outlet />}>
              <Route path="user" element={<UserSettingsView />} />
              <Route path="admin" element={<UsersListSettingsView />} />
            </Route>
          </Routes>
        </Suspense>
      </Box>
    </Box>
  );
};

export default SettingsView;
